import { render, staticRenderFns } from "./satisfiedInvestigation.vue?vue&type=template&id=9c7abd08&scoped=true"
import script from "./satisfiedInvestigation.vue?vue&type=script&lang=js"
export * from "./satisfiedInvestigation.vue?vue&type=script&lang=js"
import style0 from "./satisfiedInvestigation.vue?vue&type=style&index=0&id=9c7abd08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7abd08",
  null
  
)

export default component.exports